import React from "react";

const Java_sqrt = () => {
  return (
    <div>
      <h1>Java sqrt</h1>
      <p>This page provides explanations, examples, and common use-cases for Java sqrt in Java.</p>
    </div>
  );
};

export default Java_sqrt;
